import React, { useEffect, useState } from 'react';

function LicenseData({data}) {
  const {egm, key, status, starting, expiration, additional_parameters} = data;
  const expirationDate = expiration ? new Date(expiration).toDateString() : null;
  const keyDisplay = key.substring(0, 5) + '-' + key.substring(5, 10) + '-' + key.substring(10, 15) + '-' + key.substring(15, 20) + '-' + key.substring(20);
  return (
    <div>      
      <div>EGM: <span className='monospace'>{egm}</span></div>
      <div>Key: <span className='monospace'>{keyDisplay}</span></div>
      <div>Status: {status}</div>
      {starting && <div>Starting: {new Date(starting).toDateString()}</div>}
      {expiration && <div>Expiration: {expirationDate}</div>}
      {additional_parameters && additional_parameters.map((param, index) => (        
        <div key={index}>{param.split("=")[0]}: {param.split("=")[1]}</div>        
      ))}
    </div>
  );
}

export default LicenseData;